import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Loading from '../components/Loading';

const ProtectedRoute = ({
  layout: Layout,
  component: Component,
  isAuthenticated,
  loading,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (loading) {
        return <Loading />;
      }
      return isAuthenticated ? (
        <Layout>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      );
    }}
  />
);

ProtectedRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  isAuthenticated: false,
  loading: false,
};

const mapStateToProps = state => ({
  isAuthenticated: state.authState.isAuthenticated,
  loading: state.authState.loading,
  user: state.authState.user,
});

export default connect(mapStateToProps)(ProtectedRoute);
